/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Partner,
} from '../models/index';
import {
    PartnerFromJSON,
    PartnerToJSON,
} from '../models/index';

export interface GetCompaniesBySirenRequest {
    siren: string;
}

/**
 *
 */
export class CreditSafeApi extends runtime.BaseAPI {

    /**
     * Get companies by siren
     */
    async getCompaniesBySirenRaw(requestParameters: GetCompaniesBySirenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['siren'] == null) {
            throw new runtime.RequiredError(
                'siren',
                'Required parameter "siren" was null or undefined when calling getCompaniesBySiren().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/credit-safe/search/{siren}`;
        urlPath = urlPath.replace(`{${"siren"}}`, encodeURIComponent(String(requestParameters['siren'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Get companies by siren
     */
    async getCompaniesBySiren(requestParameters: GetCompaniesBySirenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.getCompaniesBySirenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
